<template>
  <div class="about">
    <el-row>
      <el-col>
        <public-tem v-if="active===0">
          <div slot="topShow">
            <div class="img-1"></div>
          </div>
          <div slot="mainTabs" class="tabs">
            <el-row>
              <el-col>
                <el-breadcrumb separator="/">
                  <el-breadcrumb-item>
                    <router-link to="/home">关于</router-link>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item>关于金政</el-breadcrumb-item>
                </el-breadcrumb>
              </el-col>
            </el-row>
          </div>
          <div slot="mainBody" class="container-1">
            <el-row type="flex" justify="space-around">
              <el-col :span="4">
                <div class="left">
                  <ul class="bg" id="cleft0">
                    <li class="hover" @click="setTab(0,0)">金政简介</li>
                    <li @click="setTab(0,1)">发展历程</li>
                    <li @click="setTab(0,2)">资质荣誉</li>
                    <li @click="setTab(0,3)">联系我们</li>
                    <li @click="setTab(0,4)">招贤纳士</li>
                  </ul>
                </div>
              </el-col>
              <el-col :span="20">
                <div id="rContent0" class="right">
                  <ul class="block">
                    <el-row>
                      <el-col>
                        <div class="box1-1">
                          <div class="txt1-1">
                            <span class="title1-2">金政简介</span>
                            <span class="title1-2-1">BRIEF INTRODUCTION</span>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <div class="box1-2">
                          <p
                            class="txt1-2"
                          >金政集团创立于2004年，是中国优秀的财政及行政事业单位业财融合服务集团。集团下设两家子公司，深圳市金政软件技术有限公司、北京金政日新科技有限公司，分别从不同层面发挥专业优势，深耕研究、聚力前沿，通过建立“软件+方案+咨询”一体化战略体系，为财政信息化管理及政务大数据应用提供全面、精准、智慧化的产品和服务。</p>
                          <p
                            class="txt1-2"
                          >公司获得国家高新技术企业和深圳市高新技术企业双高新、CMMI3级及ISO27001信息安全管理体系等多项认证，拥有知识产权80余项，并荣获“广东省高成长企业”称号。</p>
                          <p
                            class="txt1-2"
                          >公司现有高端软件技术人才和资深业务咨询专家近600人，服务客户约5000余家，提供专业咨询项目达1000余项。业务遍及深圳、厦门、成都、重庆、甘肃、云南等地，并在多地设立研发中心及办事处，为客户提供及时、个性化的产品和服务。</p>
                          <p class="txt1-2">紧随时代步伐，进击浪潮之巅，公司在区块链、大数据、微服务、云计算等前沿领域都有成熟的案例和核心技术人才储备。</p>
                          <p
                            class="txt1-2"
                          >金政集团将一直以重服务、重质量、重信誉为原则，继续“守初心、聚智慧，促管理”，助力政府“赢未来”，做客户信赖的长期合作伙伴。</p>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <div class="box-foot"></div>
                      </el-col>
                    </el-row>
                  </ul>
                  <ul style="display: none;">
                    <el-row>
                      <el-col>
                        <section id="cd-timeline" class="cd-container">
                          <!-- <div class="cd-timeline-block">
                            <div class="cd-timeline-img cd-picture"></div>
                          </div> -->
                          <div class="cd-timeline-block">
                            <div class="cd-timeline-img cd-picture"></div>
                            <div class="cd-timeline-content">
                              <h2>2004年公司成立</h2>
                              <p>2004年10月，深圳市金政软件技术有限公司正式成立。</p>
                            </div>
                          </div>
                          <div class="cd-timeline-block">
                            <div class="cd-timeline-img cd-picture"></div>
                            <div class="cd-timeline-content">
                              <h2>2005年</h2>
                              <p>承接深圳市市区两级部门预算编报系统的运维服务。</p>
                            </div>
                          </div>
                           <div class="cd-timeline-block">
                            <div class="cd-timeline-img cd-picture"></div>
                            <div class="cd-timeline-content">
                              <h2>2008年</h2>
                              <p>推出了行政事业单位资产全生命周期管理系统。</p>
                            </div>
                          </div>
                          <div class="cd-timeline-block">
                            <div class="cd-timeline-img cd-picture"></div>
                            <div class="cd-timeline-content">
                              <h2>2011年</h2>
                              <p>研发推出了G3财务综合管理系统。</p>
                            </div>
                          </div>
                          <div class="cd-timeline-block">
                            <div class="cd-timeline-img cd-picture"></div>
                            <div class="cd-timeline-content">
                              <h2>2013年</h2>
                              <p>研发推出了财政全业务管理平台。</p>
                            </div>
                          </div>
                          <div class="cd-timeline-block">
                            <div class="cd-timeline-img cd-picture"></div>
                            <div class="cd-timeline-content">
                              <h2>2014年</h2>
                              <p>正式通过国家高新技术企业和深圳市高新技术企业认证。</p>
                            </div>
                          </div>
                          <div class="cd-timeline-block">
                            <div class="cd-timeline-img cd-picture"></div>
                            <div class="cd-timeline-content">
                              <h2>2016年</h2>
                              <p>2016年获得CMMI3、ISO27001资质证书，重庆研发中心成立。</p>
                            </div>
                          </div>

                          <div class="cd-timeline-block">
                            <div class="cd-timeline-img cd-picture"></div>
                            <div class="cd-timeline-content">
                              <h2>2017年</h2>
                              <p>再次通过高新技术企业认证，加强知识产权和公司规范化管理，获得ISO27001体系认证、企业知识产权管理规范认证等，并获得知识产权40余项。</p>
                            </div>
                          </div>

                          <div class="cd-timeline-block">
                            <div class="cd-timeline-img cd-picture"></div>
                            <div class="cd-timeline-content">
                              <h2>2018年</h2>
                              <p>荣获“广东省高成长性企业”，肯定了公司的快速发展；同时成为深圳市资产系统指定开发商；针对会计制度变革。</p>
                            </div>
                          </div>

                          <div class="cd-timeline-block">
                            <div class="cd-timeline-img cd-picture"></div>
                            <div class="cd-timeline-content">
                              <h2>2019年</h2>
                              <p>成立北京、甘肃等分公司，业务范围向全国拓展；成为深圳市智慧城市建设的合作商之一。</p>
                            </div>
                          </div>
                          <div class="cd-timeline-block">
                            <div class="cd-timeline-img cd-picture"></div>
                            <div class="cd-timeline-content">
                              <h2>持续更新中。。。</h2>
                            </div>
                          </div>
                        </section>
                      </el-col>
                    </el-row>
                  </ul>
                  <ul class="txt1-1" style="display: none;">
                    <el-row>
                      <el-col>
                        <div class="box1-3">
                          <el-row type="flex" justify="space-around">
                            <el-col :span="10">
                              <div class="imgs-1-3"></div>
                            </el-col>
                            <el-col :span="10">
                              <div class="imgs-1-4"></div>
                            </el-col>
                          </el-row>
                        </div>
                        <div class="box1-3">
                          <el-row type="flex" justify="space-around">
                            <el-col :span="10">
                              <div class="imgs-1-5"></div>
                            </el-col>
                            <el-col :span="10">
                              <div class="imgs-1-6"></div>
                            </el-col>
                          </el-row>
                        </div>
                        <div class="box1-3">
                          <el-row type="flex" justify="space-around">
                            <el-col :span="10">
                              <div class="imgs-1-7"></div>
                            </el-col>
                            <el-col :span="10">
                              <div class="imgs-1-8"></div>
                            </el-col>
                          </el-row>
                        </div>
                        <div class="box1-3">
                          <el-row type="flex" justify="space-around">
                            <el-col :span="10">
                              <div class="imgs-1-9"></div>
                            </el-col>
                            <el-col :span="10">
                              <div class="imgs-1-10"></div>
                            </el-col>
                          </el-row>
                        </div>
                      </el-col>
                    </el-row>
                  </ul>
                  <ul class="txt1-1" style="display: none;">
                    <el-row>
                      <el-col>
                        <div class="box1-5">
                          <el-row type="flex" justify="space-around">
                            <el-col :span="12">
                              <div class="imgs-1-8"></div>
                            </el-col>
                            <el-col :span="12">
                              <div class="title2-1">
                                <p>深圳公司</p>
                                <span class="txt1-3">
                                  联系电话 ：0755-83281806
                                  <br />传真号码 ：0755-83638066
                                  <br />网 址：www.szjzsoft.com
                                  <br />地 址：深圳市龙岗区坂田天安云谷二期4栋505-512
                                </span>
                              </div>
                            </el-col>
                          </el-row>
                        </div>
                        <div class="box1-5">
                          <el-row type="flex" justify="space-around">
                            <el-col :span="12">
                              <div class="imgs-1-9"></div>
                            </el-col>
                            <el-col :span="12">
                              <div class="title2-1">
                                <p>重庆研发中心</p>
                                <span class="txt1-3">
                                  联系电话 ：023-67479525
                                  <br />地 址：重庆市渝北区新牌坊山顶道国宾城11栋17-6
                                </span>
                              </div>
                            </el-col>
                          </el-row>
                        </div>
                        <div class="box1-5">
                          <el-row type="flex" justify="space-around">
                            <el-col :span="12">
                              <div class="imgs-1-10"></div>
                            </el-col>
                            <el-col :span="12">
                              <div class="title2-1">
                                <p>北京运营总部</p>
                                <span class="txt1-3">
                                  联系电话 ：010-61199879
                                  <br />地 址：北京海淀区西直门中坤大厦1218号
                                </span>
                              </div>
                            </el-col>
                          </el-row>
                        </div>
                      </el-col>
                    </el-row>
                  </ul>
                  <ul class="txt1-1" style="display: none">
                    <div class="content">
                      <div class="join2">
                        <img src="~imgs/about/person.png" alt />
                        <div>
                          <a
                            href="https://jobs.51job.com/shenzhen-ftq/118408444.html?s=04"
                            target="_blank"
                          >
                            <div class="join-title">软件实施工程师</div>
                            <span style="margin-left:20px;">详情请点击</span>
                          </a>
                          <!-- <div class="join-content">
                    <div class="join-title2">岗位职责：</div>
                    <div class="join-content2">
                      1、提供相关软件的技术支持服务，日常软件、服务类项目培训；
                      2 、收集了解客户需求并及时反馈,解决客户软件/硬件的技术问题；
                      3 、资产系统安装维护,，统计内项目的填报；
                      4 、建立良好的客户关系，对客户进行技术培训和疑难解答；
                      5 、处理客户的电话投诉，编写相关产品问题和技术问题的报告；
                      6 、负责技术方案、技术类文档的编写工作；
                    </div>
                    <div class="join-title2">任职资格：</div>
                    <div class="join-content2">
                      1 、大专及以上学历，财务、软件工程师、计算机相关专业，
                      2 、熟练使用sql，oracle或MySQL数据库，了解一门以上开发语言；
                      3 、熟练编写一般的演示课件、技术说明文档与用户使用手册，有一定的文案写作能力。
                      4 、善于与客户沟通，有良好的客户服务意识；
                      5、有技术支持或相关工作经验，能独立解决技术类问题；
                      6、具备较强的项目控制与推进能力，较强的沟通和演讲能力；
                    </div>
                          </div>-->
                        </div>
                      </div>
                      <div class="join2">
                        <img src="~imgs/about/person.png" alt />
                        <div>
                          <a
                            href="https://jobs.51job.com/shenzhen-ftq/119144475.html?s=04"
                            target="_blank"
                          >
                            <div class="join-title">需求分析师</div>
                            <span style="margin-left:20px;">详情请点击</span>
                          </a>
                          <!-- <div class="join-content">
                    <div class="join-title2">岗位职责：</div>
                    <div class="join-content2" style="margin-bottom: 5px;">
                      1、系统需求收集、整理；
                      2、需求管理、优先级排序；
                      3、参与迭代开发计划制定；
                      4、编写需求规格、原型图、流程图；
                      5、需求澄清、验收完成的需求开发，需求变更管理。
                    </div>
                    <div class="join-title2">任职资格：</div>
                    <div class="join-content2">
                      1、3年以上工作经验，2年需求分析经验；<br>
                      2、精通需求分析的流程与要素；<br>
                      3、能输出原型图与流程图；<br>
                      4、有开发测试经验优先；<br>
                      5、有敏捷团队经验优先。
                    </div>
                          </div>-->
                        </div>
                      </div>
                      <div class="join2">
                        <img src="~imgs/about/person.png" alt />
                        <div>
                          <a
                            href="https://jobs.51job.com/shenzhen-ftq/92071479.html?s=04"
                            target="_blank"
                          >
                            <div class="join-title">会计顾问</div>
                            <span style="margin-left:20px;">详情请点击</span>
                          </a>
                          <!-- <div class="join-content">
                    <div class="join-title2">岗位职责：</div>
                    <div class="join-content2">
                      1、负责财务软件系统项目的实施；
                      2、行政事业单位账务处理支持，财务预算、决算、审核、监督等内部资金控制工作，按照要求编制各种财务报表并抱送相关部门；
                      3、调研和分析客户的需求，设计和优化业务流程，制定有针对性的解决方案，并通过专业的项目管理，协助和引导客户完成系统实施工作；
                      4、负责财务软件项目的实施支持和项目管理工作。
                    </div>
                    <div class="join-title2">任职资格：</div>
                    <div class="join-content2">
                      1、大专以上学历，财务相关专业；
                      2、熟练掌握财务、资金等其中一个领域的专业知识；
                      3、2年以上全盘账务工作经验；
                      4、工作积极主动，学习能力强，具备良好的沟通协调和解决问题能力；
                      5、有ERP或软件实施或售后维护工作经验者优先；
                    </div>
                          </div>-->
                        </div>
                      </div>
                      <!-- <div class="join2">
                <img src="~imgs/about/person.png" alt="">
                <div>
                  <a href="https://jobs.51job.com/shenzhen-ftq/119144475.html?s=04" target="_blank">
                  <div class="join-title">数据库管理工程师</div>
                  <span style="margin-left:20px;">详情请点击</span>
                  <div class="join-content">
                    <div class="join-title2">岗位职责：</div>
                    <div class="join-content2">
                      1、负责公司软件产品的数据库设计、管理与调优，对数据库整体架构提出建议；
                      2、负责公司互联网产品上线、更新、配合开发人员分析对应的SQL的优化和实现；
                      3、负责数据库的日常维护、监控、备份恢复工作；
                      4、负责数据库运维的标准化、规范化，维护数据的安全性；
                      5、维护线上业务核心数据库的安全、稳定运行。
                    </div>
                    <div class="join-title2">任职资格：</div>
                    <div class="join-content2">
                      1、计算机专业专科以上学历，2年以上mysql DBA工作经验；
                      2、熟悉MySQL/Oracle/Mongodb/Redis数据库集群管理、备份及性能调优经验，能快速定位数据库出现问的关键点；
                      3、熟悉mysql高可用性、主从复制；
                      4、精通linux，熟悉运维自动化，熟练掌握shell或python等至少一种语言，具有一定的脚本开发能力，熟悉java者优先；
                      5、良好的学习能力、团队协作能力，积极主动，乐于接受挑战，能承受工作压力。
                    </div>
                  </div>
                  </a>
                </div>
                      </div>-->
                      <div class="join2">
                        <img src="~imgs/about/person.png" alt />
                        <div>
                          <a
                            href="https://jobs.51job.com/shenzhen-ftq/118199102.html?s=04"
                            target="_blank"
                          >
                            <div class="join-title">Java工程师</div>
                            <span style="margin-left:20px;">详情请点击</span>
                          </a>
                          <!-- <div class="join-content">
                    <div class="join-title2">职责信息：</div>
                    <div class="join-content2">
                      1.2年以上java相关工作经验 <br>
                      2.能够熟练使用java开发工具，精通spring boot mybatis技术开发，熟悉SSM框架<br>
                      3.熟悉Ajax，vue，熟悉Web前台技术，es5 es6、html等<br>
                      4.具备mysql、Oracle等主流数据库开发经验；<br>
                      5.熟悉redis缓存技术：<br>
                      6.严格遵循软件过程规范进行软件开发<br>
                      7.有良好的学习能力、沟通能力和协作能力
                    </div>
                          </div>-->
                        </div>
                      </div>
                      <div class="join2">
                        <img src="~imgs/about/person.png" alt />
                        <div>
                          <a
                            href="https://jobs.51job.com/shenzhen-ftq/114395503.html?s=04"
                            target="_blank"
                          >
                            <div class="join-title">Web前端工程师</div>
                            <span style="margin-left:20px;">详情请点击</span>
                          </a>
                          <!-- <div class="join-content">
                    <div class="join-title2">岗位职责：</div>
                    <div class="join-content2">
                      1.负责公司产品的前端功能开发，包括PC、移动端、微信公众号、小程序2.协助进行框架的搭建和优化，参与项目框架的讨论和方案的出具 3.持续优化前端体验和页面响应速度，并保证兼容性和执行效率 4.负责产品的持续迭代工作
                    </div>
                    <div class="join-title2">任职资格：</div>
                    <div class="join-content2">
                      1.大专以上学历，3年以上工作经验
                      2.精通Javascript/HTML/CSS等前端技术,熟练运用DIV+CSS制作符合W3C规范的静态页面.
                      3.熟悉h5/css3 的特性，熟悉模块化，用过requireJs或者其他模块化的Js框架。
                      4.熟练使用jQuery / Bootstrap 等前端开发框架。
                      5.对各种浏览器的兼容性有一定了解，并有相关问题的解决经验；
                      6.有vue+vuex+vue-router项目经验。
                      7.熟悉ES6 规范，nodejs,熟练使用webpack打包工具。
                      8.对前端有强烈的求知欲和技术敏感度，有较强的学习能力和团队合作能力
                      9.良好的团队协作力，为人诚恳，做事踏实；
                    </div>
                          </div>-->
                        </div>
                      </div>
                      <div class="join2">
                        <img src="~imgs/about/person.png" alt />
                        <div>
                          <a
                            href="https://jobs.51job.com/shenzhen-ftq/107130284.html?s=04"
                            target="_blank"
                          >
                            <div class="join-title">销售代表</div>
                            <span style="margin-left:20px;">详情请点击</span>
                          </a>
                          <!-- <div class="join-content">
                    <div class="join-title2">岗位职责：</div>
                    <div class="join-content2">
                      1、向客户介绍本公司的相关服务，管理客户档案，完成客户经理交办的其他任务；
                      2、定期拜访客户，了解客户动态；
                      3、与客户进行沟通，及时掌握客户需要，了解客户状态；
                      4、定期对客户档案进行分析、整理，提供销售分析数据；
                      5、接受客户投诉，妥善解决问题；
                      6、参与合同的谈判与签订。
                      7、.良好的部门协助，进行有效的信息沟通，随时了解合同完成的进度及效果，以求为客户提供优质服务,确保合同完成后的回款；
                    </div>
                    <div class="join-title2">任职资格：</div>
                    <div class="join-content2">
                      1、1年以上销售经验，有过软件销售经验优先考虑；
                      2、有良好的客户服务意识，较强的学习能力、沟通能力、谈判能力；
                    </div>
                          </div>-->
                        </div>
                      </div>
                    </div>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>
        </public-tem>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <public-tem v-if="active===1">
          <div slot="topShow">
            <div class="img-2"></div>
          </div>
          <div slot="mainTabs">
            <el-row>
              <el-col>
                <el-breadcrumb separator="/">
                  <el-breadcrumb-item>
                    <router-link to="/home">关于</router-link>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item>合作伙伴</el-breadcrumb-item>
                </el-breadcrumb>
              </el-col>
            </el-row>
          </div>
          <div slot="mainBody" class="container-2">
            <el-row>
              <el-col>
                <div class="title">
                  <span class="title-1">合作共赢 共同成长</span>
                  <span class="title-2">成为我们的代理商/合作伙伴将获得以下优势</span>
                </div>
                <div class="content">
                  <el-row type="flex" justify="space-around">
                    <el-col :span="6">
                      <div class="imgs">
                        <img src="~imgs/all/1.985f7651.png" alt />
                        <span class="txt">品牌竞争力</span>
                        <p>
                          成熟的产品品牌
                          <br />专业的内控系统
                        </p>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="imgs">
                        <img src="~imgs/all/2.02d29014.png" alt />
                        <span class="txt">专业的培训</span>
                        <p>
                          第一时间获得
                          <br />全方位的培训
                          <br />1对1的售前支持
                        </p>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="imgs">
                        <img src="~imgs/all/3.98085a21.png" alt />
                        <span class="txt">丰厚的利润</span>
                        <p>
                          潜力巨大&nbsp;&nbsp;利润丰厚
                          <br />合作共赢&nbsp;&nbsp;共同成长
                        </p>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </div>
        </public-tem>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import publicTem from "@/components/publicTemplate/index";
export default {
  name: "index",
  components: {
    publicTem
  },
  data() {
    return {
      active: 0
      // tabPosition: 'left'
    };
  },
  watch: {
    $route() {
      this.active = +this.$route.params.id - 1;
      this.$nextTick(() => {
        document.documentElement.scrollTop = +this.$route.params.top;
        document.body.scrollTop = +this.$route.params.top;
      });
    }
  },
  created() {
    this.active = +this.$route.params.id - 1;
  },
  methods: {
    onChange(i) {
      this.active = i;
      this.$router.push({
        name: "about",
        params: {
          id: i + 1,
          top:
            document.body.scrollTop === 0
              ? document.documentElement.scrollTop
              : document.body.scrollTop
        }
      });
    },
    setTab(m, n) {
      var tli = document.getElementById("cleft" + m).getElementsByTagName("li");
      var mli = document
        .getElementById("rContent" + m)
        .getElementsByTagName("ul");
      var i;
      for (i = 0; i < tli.length; i++) {
        tli[i].className = i == n ? "hover" : "";
        mli[i].style.display = i == n ? "block" : "none";
      }
    }
  }
};
</script>

<style scoped>
</style>
